define([
    "jquery",
    "underscore",
    "marionette",
    "select2",
    "select2-lang/es",
    "select2-lang/ja",
    "select2-lang/ko",
    "select2-lang/zh-CN"
], function($, _, Marionette) {
    return Marionette.ItemView.extend({

        select2El : null,

        defaultValue : -1,
        defaultText : "고객의 MT4 계좌번호",

        initialize: function(config){
            // We can use external configuration for our select2,
            config.defaultValue = !_.isEmpty(config.defaultValue) ? config.defaultValue : this.defaultValue;
            config.defaultText = !_.isEmpty(config.defaultText) ? config.defaultText : this.defaultText;

            _.extend( this , config);
            this.initSelect2();
        },

        onAttach: function(){
            this.initSelect2();
        },

        initSelect2: function(){
            var that = this;
            this.select2El.select2({
                language: window.lang != "zh_CN" ? window.lang.substring(0, 2) : "zh-CN",
                theme: "bootstrap",
                // language:{
                //     "zh_CN",
                //     searching: function(){ return null; }
                // },
                // placeholder: {
                //     id:  -1, // the value of the option
                //     text: "고객의 MT4 계좌번호"
                // },
                ajax: {
                    url: "/rest_ib_members/search_ib_members",
                    method: "POST",
                    dataType: 'json',
                    delay: 250,
                    data: function (params) {
                        return {
                            q: params.term // search term
                        };
                    },
                    processResults: function (datas, params) {
                        // We change the result to match the select2 requirement
                        var items = [];
                        _.map(datas, function(data){
                            items.push({
                                id : data.mt4_account_no,
                                text : data.mt4_account_no+" ("+data.name.toUpperCase()+")"
                            });
                        });

                        return {
                            results: items
                        };
                    },
                    cache: true
                }
            });

            // After initializing the select2 we need to set the initial value manually
            this._setInitialValue();
        },

        _setInitialValue : function(){
            if(this.defaultValue != -1){
                this.select2El.append('<option value="'+this.defaultValue+'" selected="selected">'+this.defaultText+'</option>');
                this.select2El.trigger('change');
            }
        },

        getValue: function(){
            return this.select2El.val();
        }
    });
});
